<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Operasi" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <Alert
            v-if="cancelSuccess"
            :alert="{
              title: 'Berhasil membatalkan operasi',
              type: 'success',
              content: `operasi '${cancelItem.name}' berhasil dibatalkan dari sistem`,
            }"
          />
          <Alert
            v-if="cancelFailed"
            :alert="{
              title: 'Gagal membatalkan operasi',
              type: 'danger',
              content: `Terjadi kesalahan pada sistem. Operasi '${cancelItem.name}' gagal dibatalkan`,
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div>
            <div class="row mb-3">
              <div class="col-md-12">
                <!-- @include('blocks.tabs') -->
                <b-tabs pills>
                  <b-tab
                    v-for="item in tabs"
                    v-bind:key="item.title + String(Math.random(1023))"
                    :title="item.title"
                    @click="() => filterTab(item.filter)"
                    :active="item.filter == status"
                  />
                </b-tabs>
              </div>
            </div>
          </div>

          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-10">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-2">
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="rows.length > 10" value="25">
                        25 data
                      </option>
                      <option v-if="rows.length > 25" value="50">
                        50 data
                      </option>
                      <option v-if="rows.length > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <datatable
              v-if="loaded && rows.length"
              :columns="columns"
              :per-page="parseInt(perPage)"
              :data="rows"
              :filter="filter"
              class="table table-hover responsive"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{ size: 'small' }"
            />
            <Loading v-else />
            <br />
            <p v-if="rows.length">
              Menampilkan
              {{ countTotalRows }} data dari total {{ rows.length }} data
            </p>
            <datatable-pager
              v-if="loaded && rows.length"
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
            ></datatable-pager>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="row.id + String(Math.random(1023))"
      :id="'cancel' + row.id"
      @click="
        () => {
          cancel(
            row.id,
            `${row.nama_operasi} | ${row.ralan.no_rm} - ${row.ralan.pasien.nama}`
          );
        }
      "
      style="display: none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width: 40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk membatalkan operasi berikut?
            </p>
            <h4>{{ cancelItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btncancelItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmCancel(cancelItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import { HTTP } from "@/config.js";
import { data, tabs, filters, sort } from "@/data/Operasi.js";
import { updateFilter, getInputDate } from "@/data/helper.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "Operasi",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    EmptyState,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      cancelSuccess: false,
      cancelFailed: false,
      cancelItem: { id: null, name: "" },
      loaded: false,
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      created_from: getInputDate(),
      created_to: getInputDate(),
      orderBy: "desc",
      id_dokter_operator: "",
      status: "DIJADWALKAN",
      columns: [
        {
          label: "No",
          field: "number",
        },
        { label: "No Rawat", field: "ralan.no_rawat" },
        {
          label: "Jadwal Operasi",
          representedAs: (item) => `${item.tanggal} | ${item.sign_in}`,
        },
        {
          label: "Pasien",
          representedAs: (item) =>
            `${item.ralan.no_rm} | ${item.ralan.pasien.nama}`,
        },
        // { label: "kategori", field: "kategori_tindakan" },
        // { label: "Golongan", field: "golongan_tindakan" },
        { label: "Operasi", field: "nama_operasi" },
        {
          label: "Dokter Operator",
          representedAs: (item) => item.dokter_operator.formatted_nama,
        },
        {
          label: "",
          class: "dropdown",
          representedAs: (item) =>
            item.status != "DIBATALKAN"
              ? `<a class="btn btn-sm btn-success btn-icon" href="/#/operasi/detail/${
                  item.id_ralan
                }/${item.id}?fromTab=${
                  item.fromTab
                }"><i class="material-symbols-outlined">open_in_new</i></a>
                <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
                    <i class="material-symbols-outlined">apps</i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
                  <a class="dropdown-item" href="/#/operasi/form-laporan/${
                    item.id_ralan
                  }/${item.id}?fromTab=${item.fromTab}">
                      <i class="material-symbols-outlined">create</i>
                      Isi Data Operasi
                  </a>
                  <a class="dropdown-item" href="/#/operasi/form/${
                    item.id_ralan
                  }/edit/${item.id}?fromTab=${item.fromTab}">
                      <i class="material-symbols-outlined">create</i>
                      Ubah Form Pendaftaran Operasi
                  </a>
                  <a class="dropdown-item" href="/#/operasi/form-laporan/${
                    item.id
                  }">
                      <i class="material-symbols-outlined">print</i>
                      Generate Form Persetujuan
                  </a>
                  <a class="dropdown-item" href="/#/operasi/form-laporan/${
                    item.id
                  }">
                      <i class="material-symbols-outlined">print</i>
                      Generate Form Penolakan
                  </a>
                  <a class="dropdown-item" href="/#/operasi/form-ceklis/${
                    item.id_ralan
                  }/${item.id}?fromTab=${item.fromTab}">
                      <i class="material-symbols-outlined">check_box</i>
                      Isi Form Ceklis Keselamatan Operasi
                  </a>
                  <a class="dropdown-item" href="/#/operasi/form-kondisi/${
                    item.id_ralan
                  }/${item.id}?fromTab=${item.fromTab}">
                      <i class="material-symbols-outlined">create</i>
                      Isi Form Kondisi Pre dan Post Operasi
                  </a>
                  <a class="dropdown-item" href="/#/operasi/form-surveilans/${
                    item.id_ralan
                  }/${item.id}?fromTab=${item.fromTab}">
                      <i class="material-symbols-outlined">create</i>
                      Isi Form Surveilans
                  </a>
                  ${
                    item.status == "DIJADWALKAN"
                      ? `<a class="dropdown-item" data-toggle="modal" data-target="#modalDelete" onclick="document.getElementById('cancel${item.id}').click()" >
                        <i class="material-symbols-outlined">cancel</i>Batalkan Operasi
                  </a>`
                      : ""
                  }
                </div>
                `
              : ``,
          interpolate: true,
        },
        // {label: 'Address', representedAs: ({address, city, state}) => `${address}<br />${city}, ${state}`, interpolate: true}
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
    };
  },
  methods: {
    countRows() {
      let that = this;
      setInterval(function() {
        let count = document.querySelectorAll(
          ".table-responsive table.responsive tbody>tr"
        ).length;
        if (that.countTotalRows != count) {
          that.countTotalRows = count;
        }
      }, 1000);
    },
    async filterTab(filter) {
      //console.log(filter);
      this["status"] = filter;
      await this.displayList();
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      this.data.actionBtn[0].link = `${this.plainUrl}?fromTab=${this.status}`;
      try {
        let params = `?per_page=999999999999&status=${this.status}`;
        // let params=`?per_page=999999999999`;
        // if(this.status){
        //   params+=`&status=${this.status}`;
        // }
        // created from and created to filter
        if (this.created_from) {
          params += `&created_from=${this.created_from}`;
        } else {
          params += `&created_from=null`;
        }
        if (this.created_to) {
          params += `&created_to=${this.created_to}`;
        } else {
          params += `&created_to=null`;
        }
        if (this.id_dokter_operator) {
          params += `&id_dokter_operator=${this.id_dokter_operator}`;
        }
        // created from and created to filter
        if (this.orderBy) {
          params += `&orderBy=${this.orderBy}`;
        }
        //console.log(params);
        let result = await this.$store.state.HTTP.get(`operasi${params}`);
        //console.log(`operasi${params}`);
        // let result = await this.$store.state.HTTP.get(`operasi${params}`);
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          //console.log("berhasil");
          //console.log(result.data);
          this.rows = result.data.data.map((item, index) => {
            item.number = index + 1;
            item.fromTab = self.status;
            return item;
          });
          //console.log(this.rows);
          //console.log(this.rows);
          this.loaded = true;
          // this.$nextTick(() => {
          //   if (this.$refs.focusMe) {
          //     this.$refs.focusMe.focus();
          //   }
          // });
          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          let doctors = result.data.data;
          this.filters.columns[2].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          if (
            this.$store.state.role == "dokter" &&
            this.$store.state.id_dokter &&
            this.$store.state.id_dokter != "null"
          ) {
            this.id_dokter_operator = this.$store.state.id_dokter;
            ////console.log(this.id_dokter)
            updateFilter(this, this.filters, false, this.handleChange);
          }
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    cancel: async function(id, name) {
      //console.log(id);
      //console.log(name);
      this.cancelItem = {
        id: id,
        name: name,
      };
    },
    async confirmCancel(id) {
      //console.log(id);
      let formData = new FormData();
      formData.append("status", "DIBATALKAN");
      let result = await this.$store.state.HTTP.post(`operasi/${id}`, formData);
      //console.log(result);
      if (result.status == 200) {
        this.cancelSuccess = true;
        await this.displayList();
      } else {
        this.cancelFailed = true;
      }
      this.resetAlert();
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.cancelSuccess = false;
        self.cancelFailed = false;
      }, 5000);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.countRows();
    this.plainUrl = this.data.actionBtn[0].link.split("?")[0];
    if (this.$route.query.tab) {
      this.status = this.$route.query.tab;
    }
    this.fetchDoctors();
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
